import TagManager from 'react-gtm-module';
import {ENV} from './constants';

export function logGTMEvent(data) {
  if (ENV === 'prod') {
    //Log only on Prod
    TagManager.dataLayer({
      dataLayer: data,
    });
  }
}
